<template>
	<section>
		<compFormQuery class="margin-layout" :formdata="getBase" :value="formData"></compFormQuery>
		<vLoading size="large" fix :loading="loading"></vLoading>
	</section>
</template>

<script>
import { mapGetters } from 'vuex';
import { HttpProductManage } from '@/service/setting';

import mixin from './mixin';
export default {
	props: ['params'],
	mixins: [mixin],
	components: {
		compFormQuery: () => import("@components/templates/formquery"),
	},
	data() {
		return {
			formData: {},
			loading: false,
		}
	},
	created() {
		this.getDetail();
	},
	computed: {
		...mapGetters('dictionary', ['getCusproductList']),
		getBase() {
			const packages=this.formData.packages;
			return [{
				label: this.$t('global.common.sku', { defaultValue: "SKU" }),
				key: 'erpSku',
			}, {
				label: this.$t('global.common.status', { defaultValue: "状态" }),
				key: 'enable',
				options: this.getProductStatus
			}, {
				label: this.$t('global.common.project', { defaultValue: "项目" }),
				key: 'lineId',
				options: this.getCusproductList
			}, {
				label: this.$t('fbb.setting.goods_type', { defaultValue: "产品类型" }),
				key: 'productType',
				options: this.getProductType,
			}, {
				label: this.$t('fbb.setting.goods_nameEn', { defaultValue: "品名(英文)" }),
				key: 'nameEn',
			}, {
				label: this.$t('fbb.setting.goods_name', { defaultValue: "品名(中文)" }),
				key: 'name',
			}, {
				label: this.$t('fbb.setting.goods_size', { defaultValue: "单品包装尺寸(inch)" }),
				key: 'size',
				valueText: `${this.formData.itemLength}*${this.formData.itemLength}*${this.formData.itemLength}`
			}, {
				label: this.$t('fbb.setting.goods_weight', { defaultValue: "毛重(lb)" }),
				key: 'weight',
				valueText: packages&&packages.weight
			}, {
				label: this.$t('fbb.setting.goods_boxsize', { defaultValue: "外箱尺寸(cm)" }),
				key: 'boxsize',
				valueText: packages&&`${packages.packedLength}*${packages.packedWidth}*${packages.packedHeight}`
			}, {
				label: this.$t('fbb.setting.goods_boxweight', { defaultValue: "外箱毛重(g)" }),
				key: 'packedWeight',
				valueText: packages && packages.packedWeight
			}, {
				label: this.$t('fbb.setting.goods_boxcount', { defaultValue: "装箱入数" }),
				key: 'cartonPackedQty',
			}, {
				label: this.$t('fbb.setting.goods_boxtype', { defaultValue: "发货包装类型" }),
				key: 'goods_boxtype',
			}, {
				label: this.$t('fbb.setting.goods', { defaultValue: "商品Size" }),
				key: 'storageChargeSize',
			}, {
				label: this.$t('global.common.cost', { defaultValue: "FOB（美元）" }),
				key: 'cost',
			}, {
				title: this.$t('fbb.setting.inventory', { defaultValue: "库存量" }),
				key: 'inventory',
			},{
				label: this.$t('fbb.setting.goods_UPC', { defaultValue: "UPC" }),
				key: 'upc',
			}, {
				label: this.$t('fbb.setting.goods_returntype', { defaultValue: "客退处理方式" }),
				key: 'returnDealMethod',
				options: this.getReturnDealMethod
			}, {
				label: this.$t('fbb.setting.goods_isInsurance', { defaultValue: "快递保价" }),
				key: 'isInsurance',
				options: this.getIsInsurance
			}, {
				label: this.$t('fbb.setting.goods_signwervice', { defaultValue: "是否需要签收服务" }),
				key: 'isSignService',
				options: this.getIsInsurance
			}, {
				label: this.$t('fbb.setting.goods_code', { defaultValue: "识别码" }),
				key: 'categoryCode',
			},]
		}
	},
	methods: {
		getDetail() {
			this.loading = true;
			HttpProductManage({ id: this.params }).then(res => {
				this.loading = false;
				this.formData = res.data;
			}).catch(err => {
				this.loading = false;
			})
		},
	}
}
</script>